'use client'

import { useState, useCallback, useRef, useEffect } from 'react'

import { useSearch } from '@/_hooks/useSearch'
import { useThemeColor } from '@/_hooks/useThemeColor'

import ADesktopHeader from './_components/desktop/a-desktop-header'
import { AHeaderHamburger } from './_components/hamburger/a-header-hamburger'
import { AMegamenu } from './_components/megamenu/a-megamenu'
import { AMobileHeader } from './_components/mobile/a-mobile-header'

const AHeaderClient = () => {
	const [menuOpen, setMenuOpen] = useState(false)
	const [searchOpen, setSearchOpen] = useState(false)
	const [searchQuery, setSearchQuery] = useState('')
	const isHeaderTopVisibleRef = useRef(true)
	const [themeColor, setThemeColor] = useState('#ffffff')

	const {
		data: searchData,
		isLoading: isSearchLoading,
		isSearching,
		hasSearchTerm
	} = useSearch({
		search: searchQuery,
		enabled: searchOpen,
		debounceMs: 300
	})

	useEffect(() => {
		if (menuOpen) {
			setThemeColor('#4A337A')
		} else {
			setThemeColor('#ffffff')
		}
	}, [menuOpen])

	const handleHeaderTopVisibilityChange = useCallback(
		(isVisible: boolean) => {
			isHeaderTopVisibleRef.current = isVisible
			if (!menuOpen) {
				setThemeColor('#ffffff')
			}
		},
		[menuOpen]
	)

	useThemeColor(themeColor, menuOpen)

	const toggleMenu = useCallback(() => setMenuOpen(prev => !prev), [])
	const closeMenu = useCallback(() => setMenuOpen(false), [])

	const handleSearchQueryChange = useCallback((query: string) => {
		setSearchQuery(query)
	}, [])

	const handleSearchClose = useCallback(() => {
		setSearchOpen(false)
		setSearchQuery('')
	}, [])

	return (
		<>
			<ADesktopHeader
				onMenuToggle={toggleMenu}
				onLinkClick={closeMenu}
				searchOpen={searchOpen}
				setSearchOpen={setSearchOpen}
				searchQuery={searchQuery}
				onSearchQueryChange={handleSearchQueryChange}
				onSearchClose={handleSearchClose}
				searchData={searchData}
				isSearchLoading={isSearchLoading}
				isSearching={isSearching}
				hasSearchTerm={hasSearchTerm}
			/>

			<AMobileHeader
				searchOpen={searchOpen}
				setSearchOpen={setSearchOpen}
				searchQuery={searchQuery}
				onSearchQueryChange={handleSearchQueryChange}
				onSearchClose={handleSearchClose}
				searchData={searchData}
				isSearchLoading={isSearchLoading}
				isSearching={isSearching}
				hasSearchTerm={hasSearchTerm}
				onMenuToggle={toggleMenu}
				onLinkClick={closeMenu}
				menuOpen={menuOpen}
				onHeaderTopVisibilityChange={handleHeaderTopVisibilityChange}
			/>

			<div className='header-wrapper'>
				<div className='header-wrapper__mobile'>
					<AHeaderHamburger isOpen={menuOpen} onClose={closeMenu} />
				</div>

				<div className='header-wrapper__desktop'>
					<AMegamenu isOpen={menuOpen} onClose={closeMenu} />
				</div>
			</div>
		</>
	)
}

export default AHeaderClient
